// extracted by mini-css-extract-plugin
export default {"container":"_1iYD8","box":"_18nvX","title":"_3MiF_","subtitle":"_1745r","button":"_2X-E1"};